<template>
  <div>
    <rc-but-list class="back-but-data" :but-data="backButData"></rc-but-list>
    <div class="org-detail-wrapper">
      <rc-form v-bind="titleForm"></rc-form>
      <rc-form v-bind="detailForm" ref="detailForm" @submit="handleSubmit"></rc-form>
      <rc-addon-title
        label="管理员信息"
        :content-style="{ margin: '16px 0' }"
        :label-style="{ fontSize: '18px', fontWeight: 'bold', color: '#21262f' }"
      ></rc-addon-title>

      <div class="card-wrapper">
        <div class="card-content">
          <svg-icon icon-class="user-1" class="user-icon"></svg-icon>
          <div class="card-title">
            <span>{{ adminInfo.adminName }}</span>
            <div class="card-desc">
              <span class="card-desc-item">电话：{{ adminInfo.adminCellphone }}</span>
              <span class="card-desc-item">邮箱：{{ adminInfo.adminEmail }}</span>
            </div>
          </div>
        </div>
        <el-popover placement="bottom-end" trigger="hover" :visible-arrow="false">
          <svg-icon slot="reference" icon-class="more" class="more"></svg-icon>

          <ul class="more-popover">
            <!-- <li @click="editVisible = true">编辑登录信息</li> -->
            <li @click="restVisible = true">重置登录密码</li>
            <!-- <li class="danger" @click="changeVisible = true">更换管理员</li> -->
          </ul>
        </el-popover>
      </div>
      <rc-dialog
        ref="dialog"
        :visible.sync="restVisible"
        :content="resetContent"
        @dialog-confirm="handleResetConfirm"
      />
      <rc-dialog
        :destroy-on-close="true"
        :visible.sync="editVisible"
        content-type="form"
        v-bind="editDialog"
      ></rc-dialog>
      <rc-dialog
        :destroy-on-close="true"
        :visible.sync="changeVisible"
        content-type="form"
        v-bind="changeDialog"
        @dialog-confirm="handleChangeAdmin"
      ></rc-dialog>
    </div>
  </div>
</template>

<script>
import api from "@/api/business";
import userApi from "@/api/user/user";
import RcAddonTitle from "@/components/RcBase/RcAddonTitle/RcAddonTitle.vue";
export default {
  name: "OrgDetail",
  components: { RcAddonTitle },
  data() {
    return {
      backButData: [
        {
          label: "组织详情",
          type: "text",
          icon: "el-icon-back",
          prop: "router",
          name: "Business"
        }
      ],
      id: undefined,
      restVisible: false,
      changeVisible: false,
      editVisible: false,
      titleForm: {
        showSearch: false,
        form: {
          inline: true,
          closeLayout: true,
          status: "view"
        },
        data: {
          createTime: "",
          orgId: ""
        },
        formItem: [
          {
            component: "rc-input",
            prop: "createTime",
            label: "创建时间：",
            required: true,
            itemStyle: {
              marginRight: "20px",
              marginBottom: "18px"
            },
            labelStyle: {
              fontSize: "12px",
              color: "#868790"
            },
            contentStyle: {
              fontSize: "12px",
              color: "#868790"
            }
          },
          {
            component: "rc-input",
            prop: "orgId",
            label: "组织id：",
            itemStyle: {
              marginRight: "20px",
              marginBottom: "18px"
            },
            labelStyle: {
              fontSize: "12px",
              color: "#868790"
            },
            contentStyle: {
              fontSize: "12px",
              color: "#868790"
            }
          }
        ]
      },
      detailForm: {
        butData: [
          {
            label: "取消",
            valid: false,
            events: {
              click: this.viewForm
            }
          },
          {
            label: "确定",
            valid: true,
            type: "primary"
          }
        ],
        form: {
          gutter: 16,
          status: "view"
        },
        data: {
          tenantName: "无",
          socialCreditCode: "无",
          address: "无"
        },
        formItem: [
          {
            component: "rc-addon-title",
            attribute: {
              icon: "el-icon-edit",
              label: "基本信息",
              text: "编辑信息",
              extraShow: true,
              extraStyle: {
                fontSize: "14px",
                color: "#00b259"
              },
              textStyle: {
                marginLeft: "5px"
              },
              labelStyle: {
                fontSize: "18px",
                fontWeight: "bold",
                color: "#21262f"
              },
              events: {
                click: this.editForm
              }
            },
            itemStyle: {
              marginBottom: "7px"
            }
          },
          {
            component: "rc-input",
            prop: "tenantName",
            label: "组织名称：",
            rules: [
              {
                type: "string",
                required: true,
                pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,}$/,
                message: "不能输入空格，长度至少2位且不能含特殊字符"
              }
            ],
            span: 8,
            placeholder: "请输入组织名称"
          },
          {
            component: "rc-input",
            prop: "socialCreditCode",
            label: "纳税识别号：",
            rules: [
              {
                type: "string",
                min: 15,
                pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{15,}$/,
                required: true,
                message: "请输入正确的组织纳税识别号"
              }
            ],
            span: 8,
            placeholder: "请输入组织纳税识别号"
          },
          {
            component: "rc-input",
            prop: "address",
            label: "地址：",
            placeholder: "请输入地址",
            span: 8
          }
        ]
      },
      resetContent: {
        title: "确定要重置密码吗?",
        desc: "重置后用户只能使用系统默认密码登录。"
      },
      editDialog: {
        title: "编辑管理员登录信息",
        form: {},
        data: {
          phone: "",
          email: ""
        },
        formItem: [
          {
            component: "rc-input",
            label: "手机号：",
            prop: "phone",
            placeholder: "请输入手机号"
          }
        ]
      },
      changeDialog: {
        disabled: this.disabledBtn,
        imgIcon: "success",
        title: "变更组织管理员",
        desc: "选择新的租户管理员，原租户管理员将变为租户成员",
        form: {},
        data: {
          id: ""
        },
        formItem: [
          {
            component: "rc-select",
            prop: "id",
            placeholder: "请选择租户的管理员",
            label: "租户管理员",
            api: {
              model: api,
              name: "getUsersByOrg",
              params: {
                id: this.$route.query.id,
                isOwnerUser: true
              }
            },
            replaceFields: {
              value: "id",
              label: "displayName"
            },
            loadMore: false
          }
        ]
      },
      formOriginData: {},
      adminInfo: {
        adminId: "",
        adminCellphone: "",
        adminName: ""
      }
    };
  },
  created() {
    const { query } = this.$route;
    this.id = query.id;

    // 获取详情信息
    this.getOrgDetail(this.id);
  },
  methods: {
    disabledBtn(btn) {
      return btn.prop === "confirm" && !this.changeDialog.data.id;
    },
    async getOrgDetail(id) {
      try {
        const { data } = await api.getOrgDesc(id);
        const { createTime, tenantName, socialCreditCode, address, adminId } = data;
        // 初始化数据
        this.titleForm.data.createTime = createTime || "无";
        this.titleForm.data.orgId = this.id;

        this.adminInfo.adminId = adminId;

        // 初始化detail数据
        // this.detailForm.data.tenantName = tenantName;
        // this.detailForm.data.socialCreditCode = socialCreditCode;
        // this.detailForm.data.address = address;
        this.detailForm.data = data;

        this.formOriginData = { tenantName, socialCreditCode, address };
        // 调用用户信息
        await this.loadUserInfo(adminId);
      } catch (error) {
        this.$message.error("获取信息失败");
        throw new Error(error);
      }
    },
    editForm() {
      this.detailForm.form.status = "edit";
      this.detailForm.formItem[0].attribute.extraShow = false;
    },
    viewForm() {
      const { tenantName, socialCreditCode, address } = this.formOriginData;

      this.detailForm.form.status = "view";
      this.detailForm.formItem[0].attribute.extraShow = true;
      this.detailForm.data.tenantName = tenantName;
      this.detailForm.data.socialCreditCode = socialCreditCode;
      this.detailForm.data.address = address || "无";
    },
    async handleSubmit({ data }) {
      try {
        const { tenantName, socialCreditCode, address } = data;

        const {
          tenantId,
          adminId,
          enterpriseStructure,
          effect,
          deleteFlag = 0
        } = this.detailForm.data;
        const params = {
          tenantName,
          socialCreditCode,
          address,
          tenantId,
          adminId,
          enterpriseStructure,
          effect,
          deleteFlag
        };

        const { data: info } = await api.updateOrg(params);
        if (info) {
          this.$message.success("组织更新成功");
          this.formOriginData = { tenantName, socialCreditCode, address };
          this.viewForm();
        }
      } catch (error) {
        // this.$message.error('组织更新失败');
        throw new Error(error);
      }
    },
    async loadUserInfo(id) {
      try {
        const { data } = await userApi.getDetailsByIdNew(id);

        const { cellphone, email, displayName, username } = data;
        this.adminInfo.adminCellphone = cellphone || username || "无";
        this.adminInfo.adminName = displayName || "无";
        this.adminInfo.adminEmail = email || "无";
      } catch (error) {
        this.$message.error("获取管理员信息失败");
        throw new Error(error);
      }
    },
    async handleResetConfirm() {
      try {
        const params = [
          {
            id: this.adminInfo.adminId
          }
        ];
        const { data } = await userApi.resetItems(params);
        if (data) {
          this.$message.success("重置成功");
        }
      } catch (error) {
        this.$message.success("重置失败");
        throw new Error(error);
      }
    },
    async handleChangeAdmin({ data }) {
      try {
        const { id } = data;
        const params = { adminId: id, tenantId: this.id };
        const { data: user } = await api.updateOrg(params);
        if (user) {
          this.$message.success("更换成功");
          // 获取详情信息
          await this.loadUserInfo(id);
        }
      } catch (error) {
        this.$message.success("更换失败");
        throw new Error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.org-detail-wrapper {
  padding: 24px;
}

.card-wrapper {
  padding: 16px;
  border: 1px solid #dadfea;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card-content {
    display: flex;
    align-items: center;
  }

  .user-icon {
    font-size: 48px;
    margin-right: 16px;
  }

  .more {
    font-size: 30px;
  }

  .card-title {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #21252e;
    font-weight: 600;
  }

  .card-desc {
    margin-top: 15px;
    font-weight: 400;
  }

  .card-desc-item {
    margin-right: 20px;
  }
}
.back-but-data {
  padding: 0 24px;
  box-shadow: 0 2px 4px 0 rgb(33 37 46 / 12%);
  border-bottom: 1px solid #e8e8e8;
  height: 48px;
  line-height: 48px;
  ::v-deep span {
    color: $scim-text-color;
  }
}
</style>

<style lang="scss">
.more-popover {
  width: 110px;
  padding: 5px 0;

  li {
    padding: 10px;
    cursor: pointer;

    &:hover,
    &.active {
      background: $scim-color-table-block;
    }

    &.danger {
      color: rgb(222, 25, 25);
    }
  }
}
</style>
